import { PatientState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
  OnePatient: (state: PatientState) => (patientId: number) => {
    const filteredPatients = state.patients.filter((patient) => patient.id === patientId);
    if (filteredPatients.length > 0) {
      return { ...filteredPatients[0] };
    }
  },
  OneMinimalPatient: (state: PatientState) => (patientId: number) => state.minimalPatients[patientId],
  Comments: (state: PatientState) => state.patient_comments,
  OnePatientComments: (state: PatientState) => (patientId: number) => {
    const filteredComments = state.patient_comments.filter((comment) => comment.patient_id === patientId);
    return filteredComments
  },
};

const { read } = getStoreAccessors<PatientState, State>('');

export const readOnePatient = read(getters.OnePatient);
export const readOneMinimalPatient = read(getters.OneMinimalPatient);
export const readOnePatientComments = read(getters.OnePatientComments);
export const readComments = read(getters.Comments);